module.exports = __webpack_public_path__ + "img/roadmap.440464d3.svg";